import React from "react";
//components
import CloseModalButton from "pages/Quotes/components/generics/Button";
import Select from "pages/Quotes/components/generics/Select";
import { Column, Row } from "components/Layout/Grid";
import { Button } from "components/Button";
import Text from "components/Text";
//others
import "../../../Quotes/styles.scss";

const ModalCD = ({
  distributionCenters,
  selectCD,
  setSelectCD,
  handleCloseDcModal,
  onClick,
}: any) => (
  <>
    <div className="modalCD">
      <Row className="modalCDTitle">
        <Column className="mt-4">
          <Text className="color-primary font-bold px-3" size={20}>
            Por favor, selecione em qual CD* você {<br />} deseja gravar os
            itens da cotação:
          </Text>
        </Column>
      </Row>

      <Row className="flex-1" style={{ justifyContent: "center" }}>
        <Column className="" style={{ width: "210px" }}>
          <Select
            stateName="selectCD"
            options={distributionCenters}
            value={selectCD}
            skipSelectOption={false}
            className="mt-7"
            onChange={(e) => { setSelectCD(e.target.value); }}
            defaultBlankValue="Selecione o CD"
          />
        </Column>
      </Row>

      <Row
        className="modalCDButtons mt-5"
        style={{ justifyContent: "center", paddingLeft: "20px" }}
      >
        <Column className="modalCDDeleteButton">
          <CloseModalButton
            label="Cancelar"
            second
            onClick={() => handleCloseDcModal()}
            className="outline color-primary align-center button mr-4"
          />
        </Column>

        <Column>
          {!selectCD ? (
            <Button
              onClick={() => onClick()}
              className="outline"
              disabled={!selectCD}
              style={{ borderColor: "#BCBCBC" }}
            >
              <Text className="colors.gray font-bold px-3">Avançar</Text>
            </Button>
          ) : (
            <Button
              onClick={() => onClick()}
              className="bg-blockedButtonToast outline"
            >
              <Text className="color-white font-bold px-3">Avançar</Text>
            </Button>
          )}
        </Column>
      </Row>

      <Row
        style={{
          justifyContent: "center",
          paddingLeft: "20px",
          marginTop: "34px",
        }}
      >
        <Text className="color-primary">
          *Apenas os CDs sem bloqueios/travas são exibidos na lista.
        </Text>
      </Row>
    </div>
  </>
);

export default ModalCD;
